<template>
    <div>
        <div class="nav">
            <v-head></v-head>
        </div>
        <v-route :bindData="bindData"></v-route>
        <div class="container">
            <v-breadcrumb value1="首页" value2="互动交流" value3="旅游攻略" :url="url"></v-breadcrumb>
            <div class="container_box">
                <span style="font-size:18px">标签选择: </span>
      <el-tag v-for="(v,i) in bqList" :key = i style="margin-left:10px;margin-top:10px" size="medium" :type="buttonType(i)" @click="getBq(v.id,i)">{{v.name}}</el-tag>
      <el-button @click="reset" style="margin-left:20px" type="primary" size="mini">重置</el-button>
                <!--<div class="box_top">
                    <span >廉江动态</span>丨<span> 最热 </span>丨<span> 最新 </span>丨<span> 精华 </span>
                </div>-->
                <div class="box_item mt20" v-for="i in dataList">
                    <img class="i" :src="i.coverImageUrl">
                    <div class="item_right">
                        <div class="right_title hover" @click="toDetail(i.path)">
                            {{i.title}}
                            <!-- <img style="float: right;margin-right: 50px" src="../../assets/img/share.png">-->
                        </div>
                        <p >
                            {{i.summary}}
                        </p>
                        <div class="right_down">
                            时间:{{i.time}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  <span class="hover" @click="toDetail(i.path)">阅读全文 >></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <v-footer></v-footer>
    </div>
</template>

<script>
    import route from '../../components/common/route1'
    export default {
        name: "list1",
        data(){
            return{
                ljcode:null,
                columnId:null,
                rootColumnId:null,
                dataList:null,
                url:null,
                bqList:[],
                currentType:null,
                bq:null,
                bindData:[
                    {
                        name:'旅游攻略',
                        url:'#/lygl?ljcode=lygl&columnId=40288a9d6e91c70a016e91cf71920015&rootColumnId=40288a9d6e91c70a016e91c982fd0004',
                        cid:'40288a9d6e91c70a016e91cf71920015'
                    },
                    {
                        name:'游记分享',
                        url:'#/yjfx?ljcode=yjfx&columnId=40288a9d6e91c70a016e91cff15c0016&rootColumnId=40288a9d6e91c70a016e91c982fd0004',
                        cid:'40288a9d6e91c70a016e91cff15c0016'
                    },
                    {
                        name:'行程规划',
                        url:'#/xcgh?ljcode=xcgh&columnId=40288a9d6e91c70a016e91d01e460017&rootColumnId=40288a9d6e91c70a016e91c982fd0004',
                        cid:'40288a9d6e91c70a016e91d01e460017'
                    },
                    {
                        name:'旅游线路',
                        url:'#/lyxl?ljcode=lyxl&columnId=40288a9d6e91c70a016e91d046210018&rootColumnId=40288a9d6e91c70a016e91c982fd0004',
                        cid:'40288a9d6e91c70a016e91d046210018'
                    }
                ]
            }
        },
        created() {
            this.ljcode = this.$route.query.ljcode;
            this.columnId = this.$route.query.columnId;
            this.rootColumnId = this.$route.query.rootColumnId;
            this.url = ['lygl',this.rootColumnId,this.columnId];
            this.getList();
        },
        methods:{
            getList(){
                 let src = `${api}/api/cms/article/ywqxList`
                let url = `${api}/api/cms/article/list?rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&type=&pageSize=10&currentPage=1`;
                this.common.axios.get(url).then(v=>{
                    let data = v.data.data.list;
                    console.log(data);
                    data.forEach(v=>{
                        v.coverImageUrl = apiimg+v.coverImageUrl;
                        v.path = `ljcode=${this.ljcode}&rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&articleId=${v.id}`;
                        v.time = this.common.date2Local(v.createDate);
                    });
                    this.dataList = data;
                })
                this.common.axios.get(src).then((res)=>{
                this.bqList=res.data.data
      })
            },
      reset(){
      this.bq=null
      this.currentType=null
       let url = `${api}/api/cms/article/list?rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&type=&pageSize=10&currentPage=1`;
      this.common.axios.get(url).then((v) => {
        let data = v.data.data.list;
        data.forEach((v) => {
          v.coverImageUrl = apiimg + v.coverImageUrl;
          v.path = `ljcode=${this.ljcode}&rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&articleId=${v.id}`;
          v.time = this.common.date2Local(v.createDate);
        });
        this.dataList = data;
      });
    },
    getBq(v,i){
      this.currentType = i
	    this.buttonType(i)
      var url = `${api}/api/cms/article/list?rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&type=&pageSize=10&currentPage=1&ywqx=${v}`
      this.common.axios.get(url).then((v)=>{
        let data = v.data.data.list;
        data.forEach((v) => {
          v.coverImageUrl = apiimg + v.coverImageUrl;
          v.path = `ljcode=${this.ljcode}&rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&articleId=${v.id}`;
          v.time = this.common.date2Local(v.createDate);
        });
        this.dataList = data;
      })
    }, 
     buttonType(i){
      if(i === this.currentType){
          return "success"
        }else{
          return "info"
        }
    },
    toDetail(v){
                console.log(v,"v")
                this.$router.push({path:`/detail2?${v}`})
            }
        },
        components:{
            "v-route":route
        }
    }
</script>

<style lang="less" scoped>
    .nav{
        height: 350px;
        background: url("../../assets/img/廉江2.3.jpg") ;
        background-size: 100% 100%;
    }
    .container_box{
        .box_top{
            width: 400px;
            height: 22px;
            line-height: 22px;
            font-size: 16px;
            color: #159089;
            text-align: left;
            margin: 20px 0 20px 10px;
        }
        .box_item{
            height: 200px;
            border-radius:4px;
            margin-bottom: 20px;
            border-bottom: 2px solid rgb(235,235,235);
            display: flex;
            .i{
                width: 296px;
                height: 170px;
                margin-right: 20px;
            }
            .item_right{
                flex: 1;
                text-align: left;
                .right_title{
                    margin-bottom: 20px;
                    height: 20px;
                    line-height: 20px;
                    color:rgba(51,51,51,1);
                    font-size: 18px;
                }
                p{
                    font-size:14px;
                    font-weight:400;
                    color:rgba(102,102,102,1);
                    line-height: 20px;
                }
                .right_down{
                    margin-top: 20px;
                    margin-right: 20px;
                    text-align: left;
                    font-size:12px;
                    font-weight:400;
                    color:rgba(102,102,102,1);
                }
            }

        }

    }



</style>
